import { createListReducer } from 'app/redux/reducers/_reducer-factory/createListReducer';

const TEMPLATE_NAME = 'PROCEDURE';

export default createListReducer(TEMPLATE_NAME);
